document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('.js-frontModal');
  if (!modal) return;

  const body = document.querySelector('body');
  const openButtons = document.querySelectorAll('.js-frontModalButton');
  const closeButtons = document.querySelectorAll('.js-frontModalClose');

  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      modal.classList.add('is-open');
      body.classList.add('is-fixed');
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      modal.classList.remove('is-open');
      body.classList.remove('is-fixed');
    });
  });
});
